import React, { useState } from 'react'

export default function LineUpAllAway() {
  const [Awayrenk , Awasetrenk] = useState("#163962")
  return (
    <div className='TeamsAwayTeamKadro'>
       <div style={{background: ` ${Awayrenk} `}} className='TeamsAwayTeamKadroHeader'><div className='TeamsAwayTeamName'>Fenerbahçe</div><div className='TeamsAwayTeamName'>4-4-2</div></div>
       <div className='TeamsAwayTeamKadroAll'>

        </div>
   </div>
  )
}
